// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { MdArrowBack, MdDirections } from 'react-icons/lib/md';

import type { ROUTE_TYPE, ROUTE_STOP_TYPE } from '../../types/routes';
import * as selectors from '../../reducers';
import * as routesActions from '../../actions/routes';
import Button from '../Button';
import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import CardHeaderLeftGroup from '../CardHeaderLeftGroup';
// import CardHeaderRightGroup from '../CardHeaderRightGroup';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import CardHeaderTitle from '../CardHeaderTitle';
import CardHeaderSubtitle from '../CardHeaderSubtitle';
import SortableList from '../SortableList';
import RouteStop from '../RouteStop';
import RouteEmptyList from './routeEmptyList';

// import styles from './routeStopCardContent.css';


type DummyRouteStopsCardContentPropTypes = {
  route: ROUTE_TYPE,
  routeStops: Array<ROUTE_STOP_TYPE>,
  selectedRouteStopId: number,
  // onSortEnd: Function,
  sortRouteStopStarted: Function,
  onBack?: Function,
  // onClose?: Function
};


const DummyRouteStopsCardContent = ({
  route,
  sortRouteStopStarted,
  routeStops = [],
  onBack,
  selectedRouteStopId,
  // onClose
}: DummyRouteStopsCardContentPropTypes) => (
  <Fragment>
    <CardHeader>
      <CardHeaderLeftGroup>
        <Button
          size="medium"
          Icon={MdArrowBack}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
          onClick={onBack}
        />
      </CardHeaderLeftGroup>
      <CardHeaderTitleContainer>
        <CardHeaderTitle title={route.name} />
        <CardHeaderSubtitle subtitle={route.route_type} />
      </CardHeaderTitleContainer>
      {/* <CardHeaderRightGroup>
        <Button
          size='medium'
          Icon={ MdClose }
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
          onClick={ onClose }
        />
      </CardHeaderRightGroup> */}
    </CardHeader>
    <CardContent clearPaddings isExtended>
      <SortableList
        items={routeStops}
        useDragHandle
        className="medium"
        ItemComponent={RouteStop}
        onSortEnd={({ oldIndex, newIndex }) => {
          const stop = routeStops[oldIndex];
          if (oldIndex !== newIndex) {
            sortRouteStopStarted(route.id, stop.id, newIndex);
          }
        }}
        EmptyListComponent={
          () => (
            <RouteEmptyList
              Icon={MdDirections}
              title="No hay paradas registradas en esta ruta"
            />
          )
        }
        selectedRouteStopId={selectedRouteStopId}
      />
    </CardContent>
  </Fragment>
);

const RouteStopsCardContent = connect(
  (state, { id }) => ({
    route: selectors.getRoute(state, id),
    routeStops: selectors.getRouteStops(state, id),
    selectedRouteStopId: selectors.getCurrentRouteStopId(state),
  }),
  (dispatch, { id }) => ({
    onBack() {
      dispatch(routesActions.clearCurrentRouteStops());
      dispatch(routesActions.hideStopsDetail(id));
    },
    onClose() {
      dispatch(routesActions.hideStopsDetail(id));
    },
    sortRouteStopStarted(routeId: number, stopId: number, index: number) {
      dispatch(routesActions.sortRouteStopStarted(routeId, stopId, index));
    },
  }),
)(DummyRouteStopsCardContent);


export default RouteStopsCardContent;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStopsCardContent/index.jsx